import React from 'react'

import { Card } from 'antd'
import PT from 'prop-types'

const ManageTeamFunctionalityContainer = props => {
  const { children, extra, title } = props
  return (
    <Card
      bodyStyle={{ paddingTop: 8 }}
      extra={extra}
      title={
        <h2 style={{ display: 'inline', fontSize: 'inherit', fontWeight: 'inherit', margin: 0 }}>
          {title}
        </h2>
      }
    >
      {children}
    </Card>
  )
}

ManageTeamFunctionalityContainer.propTypes = {
  extra: PT.oneOfType([PT.element, PT.node]),
  title: PT.string.isRequired,
}

export default ManageTeamFunctionalityContainer
